/**
 * Created by Gaplo917 on 6/9/2017.
 */
import * as PIXI from 'pixi.js'
import * as Rx from 'rxjs'
import TWEEN from "@tweenjs/tween.js"
import Image from "../../objects/Image";
import R from "../../config/R";
import * as Events from "../../Events";
import {AnimationUtils} from "../../AnimationUtils";
import * as _ from "lodash";
import CustomAnimatedSprite from "../../objects/CustomAnimatedSprite";

export class CheckPointArrow extends PIXI.Container {
  constructor(x, y, rotation, texture){
    super()
    this.x = x
    this.y = y

    const arrow = new Image(0,0, texture)
    this.arrow = arrow


    this.addChild(arrow)

    this.pivot.x = this.width / 2
    this.pivot.y = this.height / 2
    this.rotation = rotation
    this.alpha = 0
  }

  flashing(){
    this._tween = new TWEEN.Tween(this)
      .to({alpha: 1}, 500)
      .repeat(8)
      .yoyo(true)
      .easing(TWEEN.Easing.Linear.None)
      .onComplete(() => {
      })
      .start()
  }

  remove(){
    this.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/game/characters/common/CheckPointArrow.js